import { z } from "zod"
import { ZodURLSearchParamSerializer } from "zod-urlsearchparams"
import { HiddenFilter } from "~/__generated__/graphql"

const hiddenFilterType = z.nativeEnum(HiddenFilter)

export const bookmarkSearchSchema = z.object({
  search: z.string(),
  hiddenFilter: hiddenFilterType,
})

export const bookmarkSearchSerializer = new ZodURLSearchParamSerializer(bookmarkSearchSchema, {
  search: "",
  hiddenFilter: HiddenFilter.HideHidden,
})
